import {Field, FIELD_TYPES, Model} from '../../vue-ocom/schema';

export default Model('job', {
  verbose_name: "Job",
  verbose_name_plural: "Jobs",
  fields: [
    Field('id', {label: 'ID', primary_key: true, readonly: true, hide: false, field_type: FIELD_TYPES.AutoNumber}),

    Field('customer', {
      label: "Customer",
      primary_key: false,
      readonly: false,
      required: false,
      hide: false,
      field_type: FIELD_TYPES.ForeignKey,
      ref_field_type: "Customer", ref_display_field: "name",
      default: () => {
        return null;
      }
    }),
    Field('order_date', {
      label: "Order Date",
      primary_key: false,
      readonly: false,
      hide: false,
      required: false,
      field_type: FIELD_TYPES.Date,
      default: () => {
        return new Date();
      }
    }),
    Field('po_number', {
      label: "PO Number",
      primary_key: false,
      readonly: false,
      hide: false,
      required: false,
      field_type: FIELD_TYPES.String,
      default: () => {
        return '';
      }
    }),
    Field('delivery_address', {
      label: "Delivery Address",
      primary_key: false,
      readonly: false,
      hide: false,
      required: false,
      field_type: FIELD_TYPES.String,
      default: () => {
        return null;
      }
    }),
    Field('on_site_contact', {
      label: "On Site Contact",
      primary_key: false,
      readonly: false,
      required: false,
      hide: false,
      field_type: FIELD_TYPES.ForeignKey,
      ref_field_type: "OnSiteContact", ref_display_field: "name",
      default: () => {
        return null;
      }
    }),
    Field('requested_delivery_date', {
      label: "Requested Delivery Date",
      primary_key: false,
      readonly: false,
      hide: false,
      required: false,
      field_type: FIELD_TYPES.Date,
      default: () => {
        return null;
      }
    }),
    Field('delivery_instructions', {
      label: "Delivery Instructions",
      primary_key: false,
      readonly: false,
      hide: false,
      required: false,
      field_type: FIELD_TYPES.String,
      default: () => {
        return '';
      }
    }),
    Field('scrap_pickup', {
      label: "Scrap Pickup",
      primary_key: false,
      readonly: false,
      hide: false,
      required: false,
      field_type: FIELD_TYPES.Boolean,
      default: () => {
        return true;
      }
    }),
    Field('requested_scrap_pickup_date', {
      label: "Requested Scrap Pickup Date",
      primary_key: false,
      readonly: false,
      hide: false,
      required: false,
      field_type: FIELD_TYPES.Date,
      default: () => {
        return null;
      }
    }),
    Field('invoice_no', {
      label: "Invoice No.",
      primary_key: false,
      readonly: false,
      hide: false,
      required: false,
      field_type: FIELD_TYPES.String,
      default: () => {
        return '';
      }
    }),
    Field('job_task_job', {
      label: 'Tasks',
      primary_key: false, readonly: false,
      hide: false,
      required: false,
      field_type: FIELD_TYPES.ManyToMany, ref_field_type: 'JobTask',
      default: () => {
        return []
      },
    }),
    Field('products', {
      label: "Products",
      primary_key: false, readonly: false,
      hide: false,
      required: false,
      field_type: FIELD_TYPES.ManyToMany, ref_field_type: "JobProduct",
      default: () => {
        return [];
      }
    }),
    Field('files', {
      label: "Files",
      primary_key: false, readonly: false,
      hide: false,
      required: false,
      field_type: FIELD_TYPES.ManyToMany, ref_field_type: "JobFile",
      default: () => {
        return [];
      }
    }),
    Field('modified_date', {
      label: "Modified Date",
      primary_key: false,
      readonly: false,
      hide: false,
      required: false,
      field_type: FIELD_TYPES.Date,
      default: () => {
        return null;
      }
    }),
    Field('created_date', {
      label: "Created Date",
      primary_key: false,
      readonly: false,
      hide: false,
      required: false,
      field_type: FIELD_TYPES.Date,
      default: () => {
        return null;
      }
    }),
    Field('active_start_date', {
      label: "Active Start Date",
      primary_key: false,
      readonly: false,
      hide: false,
      required: false,
      field_type: FIELD_TYPES.Date,
      default: () => {
        return new Date();
      }
    }),
    Field('active_end_date', {
      label: "Active End Date",
      primary_key: false,
      readonly: false,
      hide: false,
      required: false,
      field_type: FIELD_TYPES.Date,
      default: () => {
        return null;
      }
    }),
    Field('area', {
      label: "Area",
      primary_key: false,
      readonly: false,
      required: false,
      hide: false,
      field_type: FIELD_TYPES.ForeignKey,
      ref_field_type: "CodeArea", ref_display_field: "code",
      default: () => {
        return null;
      }
    }),
    Field('notes', {
      label: "Notes",
      primary_key: false, readonly: false,
      hide: false,
      required: false,
      field_type: FIELD_TYPES.ManyToMany, ref_field_type: "JobNote",
      default: () => {
        return null;
      }
    }),
    Field('requested_delivery_date_time_of_day', {
      label: "Requested Delivery Date Time Of Day",
      primary_key: false,
      readonly: false,
      required: false,
      hide: false,
      field_type: FIELD_TYPES.ForeignKey,
      ref_field_type: "CodeTimeOfDay", ref_display_field: "description",
      default: () => {
        return null;
      }
    }),
    Field('requested_scrap_pickup_time_of_day', {
      label: "Requested Scrap Pickup Time Of Day",
      primary_key: false,
      readonly: false,
      required: false,
      hide: false,
      field_type: FIELD_TYPES.ForeignKey,
      ref_field_type: "CodeTimeOfDay", ref_display_field: "description",
      default: () => {
        return null;
      }
    }),
    Field('map_ref', {
      label: "Map Ref",
      primary_key: false,
      readonly: false,
      hide: false,
      required: false,
      field_type: FIELD_TYPES.String,
      default: () => {
        return '';
      }
    }),
    Field('day_order', {
      label: "Day Order",
      primary_key: false,
      readonly: false,
      hide: false,
      required: false,
      field_type: FIELD_TYPES.Number,
      default: () => {
        return 0;
      }
    }),
    Field('on_hold', {
      label: "On Hold",
      primary_key: false,
      readonly: false,
      hide: false,
      required: false,
      field_type: FIELD_TYPES.Boolean,
      default: () => {
        return false;
      }
    }),
    Field('latitude', {
      label: "Latitude",
      primary_key: false,
      readonly: false,
      hide: false,
      required: false,
      field_type: FIELD_TYPES.Number,
      default: () => {
        return '';
      }
    }),
    Field('longitude', {
      label: "Longitude",
      primary_key: false,
      readonly: false,
      hide: false,
      required: false,
      field_type: FIELD_TYPES.Number,
      default: () => {
        return '';
      }
    }),
    Field('when', {
      label: "When",
      primary_key: false,
      readonly: false,
      hide: false,
      required: false,
      field_type: FIELD_TYPES.Date,
      default: () => {
        return null
      }
    }),
  ]
});
